"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function asDate(_a) {
    var day = _a.day, month = _a.month, year = _a.year;
    return parse(day + "." + month + "." + year);
}
exports.asDate = asDate;
function parse(dateString, formatString, locale) {
    if (formatString === void 0) { formatString = 'DD.MM.YYYY'; }
    if (locale === void 0) { locale = 'de-de'; }
    if (locale !== 'de-de' || formatString !== 'DD.MM.YYYY') {
        throw new Error('only german dates with format DD.MM.YYYY are supported at the moment');
    }
    if (!dateString) {
        return null;
    }
    // TODO: use the parser of date-fns if v2 is released in a stable version
    var result = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(dateString.trim());
    if (result === null) {
        return null;
    }
    var year = parseInt(result[3], 10);
    var month = parseInt(result[2], 10);
    var day = parseInt(result[1], 10);
    var dateCandidate = new Date(year, month - 1, day);
    if (year !== dateCandidate.getFullYear() ||
        month - 1 !== dateCandidate.getMonth() ||
        day !== dateCandidate.getDate()) {
        return null;
    }
    return dateCandidate;
}
exports.parse = parse;
//# sourceMappingURL=date.js.map
